import { Truck } from "lucide-react";
import { BlockCategory, registerBlock } from "../../lib/register-block";
import { ReturnShippingInstructionsEditorRenderer } from "./editor";
import { ReturnShippingInstructionsEmailRenderer } from "./email";
import { ReturnShippingInstructionsPanelRenderer } from "./email-panel";
import type { ReturnShippingInstructionsBlockProps } from "./types";

export default registerBlock<ReturnShippingInstructionsBlockProps>({
  type: "return-shipping-instructions",
  name: "editorBlocksLibrary.blocks.return-shipping-instructions.title",
  description: "editorBlocksLibrary.blocks.return-shipping-instructions.description",
  Icon: Truck,
  category: BlockCategory.RETURN,
  hasDynamicContent: true,
  // The built-in defaults cover every locale, so the block is never "untranslated".
  isTranslated: () => true,
  components: {
    email: {
      component: ReturnShippingInstructionsEmailRenderer,
      editor: {
        component: ReturnShippingInstructionsEditorRenderer,
      },
      configPanel: {
        features: {
          delete: true,
        },
        component: ReturnShippingInstructionsPanelRenderer,
      },
      compatibility: {
        rowBlock: false,
      },
    },
  },
});

export type { ReturnShippingInstructionsBlockProps } from "./types";
